import convertFormData from '@module/utils/convertFormData';
import convertFormDataWithArray from '@module/utils/convertFormDataWithArray';
import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { AddBookmarkParams, AddBookmarkResponse, DeleteBookmarkParams, DeleteBookmarkResponse } from './type';

export const addBookmark = async (addBookmarkParams: AddBookmarkParams) => {
  const res = await fetchExtended(`/v1/bookmark/add`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(addBookmarkParams),
  });

  const result = await res.json();

  return result as AddBookmarkResponse;
};

export const deleteBookmark = async (deleteBookmarkParams: DeleteBookmarkParams) => {
  const res = await fetchExtended(`/v1/bookmark/delete`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormDataWithArray(deleteBookmarkParams),
  });

  const result = await res.json();

  return result as DeleteBookmarkResponse;
};
